import { makeAutoObservable } from "mobx"

import { SolutionCategory, SolutionData } from "@framework/types/solution"
import { SOLUTION_STORE_STORAGE_KEY } from "@framework/constants/auth"
import { QueryFilter, QueryFilterData } from "@framework/types/query-filter"

import SolutionPermissionStore from "./permission.store"

export class SolutionsStore {
  constructor() {
    makeAutoObservable(this)
    this.loadFromLocalStorage()
  }

  permissions = new SolutionPermissionStore()

  isLoading: boolean = false

  isFiltersLoading: boolean = false

  searchLoading: boolean = false

  isPaginationLoading: boolean = false

  isAllSolutionsLoading: boolean = false

  isRecentActivityShown: boolean = false

  /**
   * the recent activity ("History") panel is rendered by the fact finder only,
   * so the sidebar entry that opens it is available on those screens only
   */
  isRecentActivityAvailable: boolean = false

  errorMessage: string = ""

  solutions: SolutionData[] | null = null

  allSolutions: SolutionData[] | null = null

  category: SolutionCategory | null = null

  appliedFilters: QueryFilterData[] = []

  availableFilters: QueryFilter | null = null

  searchedFilters: QueryFilterData[] = []

  selectedCompanyId?: string

  showRecentActivity = (show: boolean) => {
    this.isRecentActivityShown = show
  }

  setRecentActivityAvailable = (available: boolean) => {
    this.isRecentActivityAvailable = available
  }

  setSolutions = (solutions: SolutionData[]) => {
    this.solutions = solutions
  }

  setAllSolutions = (solutions: SolutionData[]) => {
    this.allSolutions = solutions
    this.saveToLocalStorage()
  }

  get solutionsMap() {
    return new Map(
      [...(this.solutions ?? []), ...(this.allSolutions ?? [])].map((it) => [
        it.id,
        it,
      ])
    )
  }

  get getByIndex() {
    const data = this.solutions ?? []
    return (index: number) => {
      return data[index]
    }
  }

  get getById() {
    const { solutionsMap } = this
    return (solutionId: string) => {
      return solutionsMap.get(solutionId)
    }
  }

  saveToLocalStorage() {
    const data = {
      category: this.category,
    }
    localStorage.setItem(SOLUTION_STORE_STORAGE_KEY, JSON.stringify(data))
  }

  loadFromLocalStorage() {
    const data = localStorage.getItem(SOLUTION_STORE_STORAGE_KEY)
    if (data) {
      const parsedData = JSON.parse(data)
      this.category = parsedData.category
    }
  }
}

export default SolutionsStore
